






























































































































































































import { readUserProfile } from '@/store/main/getters';
import { Vue, Component, Prop } from 'vue-property-decorator';
import {FmvAvatar} from 'fmv-avatar';
import { api } from '@/api';
import CustomSelectInput from '@/components/vui-luma/Ui/CustomSelectInput.vue';
import { IUserTask } from '@/interfaces/user_tasks';

@Component({
  components: {
    FmvAvatar,
    CustomSelectInput,
  },
})
export default class TaskViewModal extends Vue {
  // @ts-ignore
  @Prop({required: true, default: false}) readonly public showModal: boolean;
  // @ts-ignore
  @Prop({required: true}) readonly public task: IUserTask;
  // @ts-ignore
  @Prop({required: false, default: null}) readonly public viewAs: number | null;

  public writeResult: boolean = false;
  public result: string = '';
  public tagIds: any = [];
  public groupIds: any = [];
  public status: any = null;

  public loadingState = {
    submit: false,
    submit_result: false,
  };

  public mounted() {
    this.tagIds = this.task.linked_user.tags_ids;
    this.groupIds = this.task.linked_user.groups_ids;
    if (this.task.ticket) {
      this.status = this.task.ticket.status;
    }
  }

  public async handleChangeStatus(status: number) {
    this.loadingState.submit = true;
    try {
      const response = await api.updateUserTask(
        this.$store.getters.token,
        {
          pk: this.task.id,
          status,
        },
      );
      if (status === 3) {
        this.writeResult = true;
      } else {
        // @ts-ignore
        this.showToast(this, this.$t('Changes saved'));
        this.$emit('task-updated', null);
      }
    } catch (e) {
      // @ts-ignore
      this.showToast(this, this.$t('Error'), 'error');
    }
    this.loadingState.submit = false;
  }

  public async handleSubmitResult(createNew = false) {
    this.loadingState.submit_result = true;
    await this.handleSubmit();
    try {
      const response = await api.updateUserTask(
        this.$store.getters.token,
        {
          pk: this.task.id,
          result: this.result,
        },
      );
      this.writeResult = false;
      // @ts-ignore
      this.showToast(this, this.$t('Changes saved'));
      if (createNew) {
        this.$emit('task-updated', this.task.linked_user.pk);
      } else {
        this.$emit('task-updated', null);
      }
    } catch (e) {
      // @ts-ignore
      this.showToast(this, this.$t('Error'), 'error');
    }
    this.loadingState.submit_result = false;
  }

  public async handleSubmit() {
    if (this.task.ticket) {
      try {
        const response = await api.updateTicket(
          this.$store.getters.token,
          {
            // @ts-ignore
            ticket_id: this.task.ticket.id,
            // tags: this.tagIds, groups: this.groupIds,
            status: this.status,
          },
        );
      } catch (e) {
        // @ts-ignore
        this.showToast(this, this.$t('Error'), 'error');
      }
    } else {
      // try {
      //   const response = await api.updateLeadSettings(
      //     this.$store.getters.token,
      //     {
      //       // @ts-ignore
      //       user_id: this.task.linked_user.pk,
      //       // tags: this.tagIds, groups: this.groupIds,
      //     },
      //   );
      // } catch (e) {
      //   // @ts-ignore
      //   this.showToast(this, this.$t('Error'), 'error');
      // }
    }
  }

  get userProfile() {
    return readUserProfile(this.$store);
  }

  public handleViewProfile() {
    this.$emit('close-modal');
    this.$router.push(`/user/view-details/${this.task.linked_user.pk}`);
  }

  public handleChangeTag(value) {
    const newList: any = [];
    for (const [key, val] of Object.entries(value)) {
      // @ts-ignore
      newList.push(val.id);
    }
    this.tagIds = newList;
  }

  public handleChangeGroup(value) {
    const newList: any = [];
    for (const [key, val] of Object.entries(value)) {
      // @ts-ignore
      newList.push(val.id);
    }
    this.groupIds = newList;
  }
}
